import { ref } from 'vue';
import apiService from '@services/base/apiService';

export function useKlankbordVerzoek() {
  const showKlankbordModal = ref(false);
  const klankbordLoading = ref(false);
  const klankbordResultaat = ref<'idle' | 'succes' | 'error'>('idle');

  async function verstuurKlankbordVerzoek() {
    klankbordLoading.value = true;
    try {
      const response = await apiService.apiClient.get<boolean>('/net/home/KlankbordVerzoek');
      klankbordResultaat.value = response.data ? 'succes' : 'error';
    } catch {
      klankbordResultaat.value = 'error';
    } finally {
      klankbordLoading.value = false;
    }
  }

  function openKlankbordModal() {
    klankbordResultaat.value = 'idle';
    showKlankbordModal.value = true;
  }

  function sluitKlankbordModal() {
    showKlankbordModal.value = false;
  }

  return {
    showKlankbordModal,
    klankbordLoading,
    klankbordResultaat,
    verstuurKlankbordVerzoek,
    openKlankbordModal,
    sluitKlankbordModal,
  };
}
